"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tooltip = exports.ProTip = exports.HelpTooltip = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _styles = require("@material-ui/core/styles");
var _tailwind = require("../../tailwind.config");
var _excluded = ["title", "children"],
  _excluded2 = ["title", "children"],
  _excluded3 = ["action", "title", "style", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Tooltip = exports.Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if ((0, _isNil["default"])(title)) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], (0, _extends2["default"])({}, rest, {
    enterDelay: 300,
    title: title
  }), children);
};
Tooltip.defaultProps = {
  title: undefined
};
var LightTooltip = (0, _styles.withStyles)(function (_ref2) {
  var palette = _ref2.palette;
  return {
    tooltip: {
      backgroundColor: palette.card.main,
      color: palette.text.secondary,
      boxShadow: '-1px 0px 8px 4px rgb(0 0 0 / 10%)',
      fontSize: _tailwind.theme.fontSize.xs,
      fontWeight: _tailwind.theme.fontWeight.normal
    },
    arrow: {
      color: palette.card.main,
      height: 7
    },
    popperArrow: {
      '&[x-placement*="bottom"] $arrow': {
        marginTop: -7
      },
      '&[x-placement*="top"] $arrow': {
        marginBottom: -7
      }
    }
  };
})(Tooltip);
var HelpTooltip = exports.HelpTooltip = function HelpTooltip(_ref3) {
  var title = _ref3.title,
    children = _ref3.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(LightTooltip, (0, _extends2["default"])({}, rest, {
    title: title,
    arrow: true
  }), children);
};
var makeProTipStyles = function makeProTipStyles(styles) {
  return (0, _styles.makeStyles)(function (_ref4) {
    var palette = _ref4.palette;
    return {
      popper: {
        pointerEvents: 'auto',
        zIndex: styles.zIndex || '1500!important'
      },
      tooltip: _objectSpread({
        borderRadius: '8px',
        fontSize: '1rem',
        fontFamily: 'Helvetica Neue, Regular',
        width: 'calc(300px - 48px)',
        padding: '16px',
        background: palette.primary.main
      }, styles),
      arrow: {
        fontSize: '1.2rem',
        color: palette.primary.main
      }
    };
  });
};
var ProTip = exports.ProTip = function ProTip(_ref5) {
  var action = _ref5.action,
    title = _ref5.title,
    _ref5$style = _ref5.style,
    style = _ref5$style === void 0 ? {} : _ref5$style,
    onClick = _ref5.onClick,
    rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded3);
  var classes = makeProTipStyles(style)();
  var handleOnClick = function handleOnClick(e) {
    e.stopPropagation();
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/_react["default"].createElement(Tooltip, (0, _extends2["default"])({}, rest, {
    arrow: true,
    classes: _objectSpread({}, classes),
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-row select-none",
      onClick: handleOnClick
    }, title, !!action && /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt-2"
    }, action))
  }));
};
var _default = exports["default"] = Tooltip;
//# sourceMappingURL=index.js.map